import { SliceBorder, Button } from "../../../../shared/ui";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useState, memo } from "react";
import { useSendFormMutation } from "../..";

import { VacancyApplyFormSchema, applyForm } from "../../consts";
import {
    VacancyControlInputText,
    VacancyControlInputPhone,
    VacancyControlInputFile,
    VacancyControlInputCheckbox,
} from "../VacancyControlInput";

import type { FC } from "react";
import type { IVacancyApplyForm } from "../../types";

import styles from "./VacancyApplyForm.module.scss";
import { useMediaQuery } from "../../../../shared/hooks/useMediaQuery";
import { MediaQueryProperty, MediaSizeEnum } from "../../../../shared/constants/media";
import { generateMediaQuery } from "../../../../shared/lib/helpers";
import { useParams } from "react-router-dom";

const mediaQuery = generateMediaQuery(MediaQueryProperty.MaxWidth, MediaSizeEnum.sm);

export const VacancyApplyForm: FC = memo(() => {
    const { id: vacancyId } = useParams<"id">();

    const isMobile = useMediaQuery(mediaQuery);

    const [isFill, setIsFill] = useState(false);

    const {
        control,
        getValues,
        handleSubmit: onSubmit,
        reset,
    } = useForm<IVacancyApplyForm>({
        resolver: yupResolver(VacancyApplyFormSchema),
        defaultValues: applyForm,
    });

    const [sendForm, { isLoading: isLoadingForm }] = useSendFormMutation();

    const handleSubmit = async (args: IVacancyApplyForm) => {
        try {
            if (vacancyId) {
                await sendForm({ ...args, vacancyId }).unwrap();
                reset();
            }
        } catch (err: unknown) {
            console.error(err);
        }
    };

    const props = {
        control,
        onChangeFill: () => setIsFill(Object.values(getValues()).every(Boolean)),
    };

    return (
        <form className={styles.form} onSubmit={onSubmit(handleSubmit)} id="form">
            <h2 className={styles.title}>
                Откликнуться
                <br />
                на&nbsp;вакансию
            </h2>
            <VacancyControlInputText name="name" placeholder="Фамилия и имя" {...props} />
            <VacancyControlInputText name="city" placeholder="Город проживания" {...props} />
            <VacancyControlInputText name="email" placeholder="Email" {...props} />
            <VacancyControlInputPhone name="phone" {...props} />
            <VacancyControlInputFile name="resume" {...props} />
            <VacancyControlInputCheckbox name="personalData" {...props} />
            <SliceBorder
                sizeRadius={isMobile ? 12 : 18}
                border={{
                    bottomRight: "outside-corner-lateral",
                    topRight: "inside",
                    topLeft: !isMobile ? "outside-corner-upper" : undefined,
                }}
                className={styles.sliceBorder}
            >
                <Button as="button" type="submit" isDisabled={!isFill} size="s" loading={isLoadingForm}>
                    Откликнуться
                </Button>
            </SliceBorder>
        </form>
    );
});

VacancyApplyForm.displayName = "VacancyApplyForm";
